// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoader_container__2WSP1"};